/**
 * Slack Connector - OAuth2 bot flow
 * Follows Teams/Gmail connector pattern
 */

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Get Slack credentials and initiate OAuth flow
 */
export const getSlackCredentialsAndCreateToken = async (ctdId, mcId, masterConnectors) => {
  try {
    console.log('Initiating Slack OAuth flow...');
    console.log('Connector ID (ctdId):', ctdId);
    console.log('Master Connector ID (mcId):', mcId);

    const slackMasterConnector = masterConnectors.find(mc =>
      (mc.mcRecId?.toString() === mcId?.toString() || mc.mcId?.toString() === mcId?.toString()) &&
      (mc.mcName === 'Slack' || (mc.mcName && mc.mcName.toLowerCase().includes('slack')))
    );

    if (!slackMasterConnector) {
      throw new Error('Slack master connector not found');
    }

    localStorage.setItem('PendingSlackConnectorId', ctdId);
    localStorage.setItem('PendingSlackMcId', mcId);
    localStorage.setItem('ConnectorType', 'Slack');

    const redirectUri = process.env.REACT_APP_OAUTH_REDIRECT_URI;
    const state = ctdId;

    const jwtToken = localStorage.getItem('token');
    const response = await fetch(`${BACKEND_URL}synctrack/slack/auth-url`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${jwtToken}`,
      },
      body: JSON.stringify({
        mcId: mcId,
        redirectUri: redirectUri,
        state: state,
      }),
    });

    if (!response.ok) {
      const errorText = await response.text();
      console.error('Backend error:', errorText);
      throw new Error(`Failed to get auth URL: ${response.status}`);
    }

    const data = await response.json();
    console.log('Got Slack OAuth URL, redirecting...');
    window.location.href = data.authUrl;
    return null;
  } catch (error) {
    console.error('Error initiating Slack OAuth:', error);
    throw error;
  }
};

/**
 * Exchange Slack OAuth authorization code for access token
 */
export const exchangeSlackAuthCodeForToken = async (authCode, ctdId, mcId) => {
  try {
    console.log('Exchanging Slack auth code for token...');

    const jwtToken = localStorage.getItem('token');
    const redirectUri = process.env.REACT_APP_OAUTH_REDIRECT_URI;

    const params = {
      code: authCode,
      mcId: mcId,
      ...(ctdId ? { ctdId } : {}),
      ...(redirectUri ? { redirectUri } : {}),
    };
    const response = await fetch(`${BACKEND_URL}synctrack/slack/token`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        'Accept': 'application/json',
        'Authorization': `Bearer ${jwtToken}`,
      },
      body: new URLSearchParams(params),
    });

    if (!response.ok) {
      const errorText = await response.text();
      console.error('Backend error response:', errorText);
      throw new Error(`Token exchange failed: ${response.status} ${response.statusText}`);
    }

    const tokenData = await response.json();
    console.log('Slack token received successfully');

    return {
      access_token: tokenData.access_token,
      refresh_token: tokenData.refresh_token || null,
      expires_in: tokenData.expires_in != null ? tokenData.expires_in : 0,
      scope: tokenData.scope,
      token_type: tokenData.token_type || 'Bearer',
    };
  } catch (error) {
    console.error('Error exchanging Slack auth code:', error);
    throw error;
  }
};
